import React, { useEffect, useRef, useState } from 'react'
import Sidebar from '../../components/Sidebar/Sidebar'
import { Outlet } from 'react-router-dom'
import Header from '../../components/Header/Header'
import NewHeader from '../../components/Header/newHeader'
import NewFooter from '../../components/Footer/footer'


const Patient = () => {
    return (
        // <div className='flex'>
        //     <Sidebar/>

        //     <Outlet/>
        // </div>
        <div
        // style={{ background: 'linear-gradient(to bottom right, #FFFFFF, #BDC8F2)' }}

        className=" min-h-screen"
        >
            <div className='ContentPageBG'>
                <NewHeader />
                <div className={`pt-5 flex flex-col flex-1 min-h-screen transition-padding transition-slowest ease z-10 overflow-y-auto no-scrollbar`}>
                    <div className=''>
                        <Outlet />
                        <NewFooter />
                    </div>
                </div>
            </div>
        </div>


    )
}

export default Patient
